import ConvenioNovo from './ConvenioNovo';

export default ConvenioNovo;